/* eslint-disable import/order */
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsCustomerServiceCannedResponsesRoute } from '@jira/router-routes__project-settings-customer-service-routes/src/projectSettingsCustomerServiceCannedResponsesRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { projectSettingsCannedResponsesPageEntrypoint } from './ui/project-settings-canned-responses/index.tsx';

export const projectSettingsCustomerServiceCannedResponsesRouteEntry: Route = createEntry(
	projectSettingsCustomerServiceCannedResponsesRoute,
	() => ({
		group: 'project-settings-servicedesk',
		ufoName: 'jcs-project-settings.canned-responses',

		entryPoint: () => {
			return fg('csm_canned_responses_improvements')
				? projectSettingsCannedResponsesPageEntrypoint
				: undefined;
		},

		layout: serviceProjectLayout,

		navigation: {
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
